<template>
  <div class="modal-container clearfix">
    <div class="containerM">
      <img style="height: 25px;width: 25px;margin-top: 15px" src="@/assets/images/common/error.png"/>
      <pre style="max-height:200px;width:100%;overflow-y:auto;margin-left: 10px" v-html="message"></pre>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="close" v-if="isClear || isCommit">取 消</Button>
      <Button type="primary" @click="clear" v-if="isClear">强制清分</Button>
      <Button type="primary" @click="close" v-if="!conImport && !isClear">确 认</Button>
      <Button type="primary" @click="cover" v-if="conImport">{{ btnText }}</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  props: {
    conImport: {
      type: Boolean,
      default: false
    },
    isClear: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      default: '继续导入'
    },
    isCommit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      message: ''
    };
  },
  methods: {
    setMessage(message) {
      this.message = message;
    },
    close() {
      this.$emit('close');
    },
    cover() {
      this.$emit('cover');
    },
    clear() {
      this.$emit('clear');
    }
  }
};
</script>

<style>
.containerM {
  display: flex;
  width: 100%;
}
</style>